"use client"

import { useState } from "react"
import "./MobileFaq.css"

const faqData = [
  {
    question: "What is Mobile development?",
    answer:
      "Mobile Development consists of creating optimized software that is intended to run on mobile devices. Mobile applications have unique features and hardware, and they can assume many types, such as native apps or hybrid apps.",
  },
  {
    question: "How much does it cost to build a mobile app?",
    answer:
      "The cost of your mobile app will depend on whether it has a back-end in place or not. If your mobile app already has a back-end in place, the average hourly cost of a software developer varies between $50 000* to $80 000*. If it doesn’t have back-end, it has an average increase of 50%.*Note: Rates may vary based on currency.Useful link:• Time & Materials contract - which one is the best option for your software, web, or mobile app development product?",
  },
  {
    question: "How long does it take to develop a mobile app?",
    answer:
      "If you plan to have a mobile app built from scratch, the average time to develop is never less than 2 months.",
  },
  {
    question: "Can you make apps for both ios and android?",
    answer:
      "Yes. The mobile applications we build support both iOS app development and Android app development. It’s common for people to want their apps to work across web and mobile devices, so we use key development frameworks that enable us to quickly support both platforms.Take a look at some of our app development process case studies.",
  },
  {
    question: "What programming languages and framework you use tu build a mobile app?",
    answer:
      "We use React Native for most mobile app development, as well as Flutter.Take a look at some of our app development features:• React Native vs Flutter for app development• Vue.js vs React: We built an app on both frameworks",
  },
  
]

const ScopingFAQ = () => {
  const [openItems, setOpenItems] = useState([])

  const toggleItem = (index) => {
    setOpenItems((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]))
  }

  return (
    <div className="faq-container" id="faq">
      <div className="container">
      <div className="faq-wrapper">
        {/* Header */}
        <div className="header-section8166">
          <h1 className="main-title">EVERYTHING YOU NEED TO KNOW ABOUT</h1>
          <h2 className="sub-title">MOBILE DEVELOPMENT SERVICES</h2>
        </div>

        <div className="content-grid">
          {/* Left Sidebar */}
          <div className="sidebar">
            <div className="sidebar-image">
              <img src="/faq.webp?height=10&width=10" alt="FAQ Illustration" />
            </div>

            <div className="sidebar-content">
              <p className="sidebar-text">
                Browse the Frequently Asked Questions and get your answers. Or better yet - get in touch with our team
                and let's talk!
              </p>
              <button className="quote-button">GET A QUOTE</button>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="faq-section">
            <div className="faq-list">
              {faqData.map((faq, index) => (
                <div key={index} className="faq-item">
                  <div className="faq-question" onClick={() => toggleItem(index)}>
                    <p className="question-text">{faq.question}</p>
                    <div className="chevron-icon">
                      {openItems.includes(index) ? (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="18,15 12,9 6,15"></polyline>
                        </svg>
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="6,9 12,15 18,9"></polyline>
                        </svg>
                      )}
                    </div>
                  </div>
                  {openItems.includes(index) && (
                    <div className="faq-answer">
                      <p className="answer-text">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Scroll Indicator */}
            <div className="scroll-indicator">
              <div className="scroll-dot"></div>
              <div className="scroll-bar"></div>
              <div className="scroll-dot"></div>
            </div>
          </div>
        </div>

        {/* Bottom CTA Section */}
        <div className="cta-section">
          <div className="cta-content">
            <div className="cta-text">
              <h3 className="cta-title">STILL HAVE QUESTIONS?</h3>
              <p className="cta-description">
                Our team of business developers and project managers can help you to clarify any questions you have
                related. Feel free to chat with us anytime.
              </p>
            </div>
            <button className="call-button">BOOK A CALL</button>
          </div>
        </div>
      </div>
      </div>
    </div>
  )
}

export default ScopingFAQ;
